import React, { FC, ReactNode } from 'react';
import { GatsbyBrowser, PageProps, GatsbySSR } from 'gatsby';
import Helmet from 'react-helmet';
import { SessionConfigProvider } from '@quantum/ui-core';
import { domainFromUrl, hostUrl } from '@/helpers/domainUrl';
import { Header } from '@/components/header';

const whereShouldRender = ['/recommendation'];

const shouldRender = (pathName: string): boolean => whereShouldRender.some(path => pathName.includes(path));

const onetrustscriptid: { [key: string]: { [key: string]: string } } = {
  com: {
    development: '198b51f6-5b37-4b63-a601-810a86d648f0-test',
    staging: '198b51f6-5b37-4b63-a601-810a86d648f0-test',
    production: '198b51f6-5b37-4b63-a601-810a86d648f0',
  },
  ie: {
    development: 'db986ee0-212f-428c-86c8-74aecb641ce8-test',
    staging: 'db986ee0-212f-428c-86c8-74aecb641ce8-test',
    production: 'db986ee0-212f-428c-86c8-74aecb641ce8',
  },
  uk: {
    development: '3b1d1456-a7f1-4509-b411-7a08e0189f07-test',
    production: '3b1d1456-a7f1-4509-b411-7a08e0189f07',
  },
  localhost: {
    local: '198b51f6-5b37-4b63-a601-810a86d648f0-test',
  },
};

interface WrapperProps {
  props: PageProps;
  children?: ReactNode;
}
interface PageContext {
  [key: string]: string | boolean | number | unknown;
  tld?: string;
  locale: string;
  forMobileApp?: boolean;
}

const Wrapper: FC<WrapperProps> = ({ props: { location, pageContext }, children }) => {
  const pageContextWrapper = pageContext as PageContext;
  return (
    <SessionConfigProvider>
      <Helmet>
        <script
          key='onetrustscriptid'
          src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
          type='text/javascript'
          charSet='UTF-8'
          data-domain-script={onetrustscriptid[domainFromUrl(hostUrl)]?.[process.env.production || '']}
          async
        />
      </Helmet>
      {shouldRender(location.pathname) && (
        <>
          <Header locale={pageContextWrapper.locale} />
          <main>{children}</main>
        </>
      )}
      {!shouldRender(location.pathname) && children}
    </SessionConfigProvider>
  );
};

export const Page: GatsbyBrowser['wrapPageElement'] = ({ element, props }): JSX.Element => (
  <Wrapper props={props}>{element}</Wrapper>
);

export const PageSSR: GatsbySSR['wrapPageElement'] = ({ element, props }): JSX.Element => (
  <Wrapper props={props}>{element}</Wrapper>
);
